import {LegendItem} from '@hconnect/common/components/runningTimes/LegendItem'
import {InfoOutlined} from '@mui/icons-material'
import {Stack, Tooltip} from '@mui/material'
import {RUNNING_TIME_COLOR} from '@widgets/common-running-times'
import {useTranslation} from 'react-i18next'

import {RUNNING_TIMES_WIDGET_NAMESPACE} from '../consts'

export const OperationHoursLegendTooltip = () => {
  const {t} = useTranslation(RUNNING_TIMES_WIDGET_NAMESPACE)

  return (
    <Tooltip
      enterTouchDelay={0}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'background.paper'
          }
        }
      }}
      title={
        <Stack spacing={0.5} ml={{sm: 1}}>
          <LegendItem color={RUNNING_TIME_COLOR.running} label={t('runningTime.legend.running')} />
          <LegendItem
            color={RUNNING_TIME_COLOR.stoppedUndefined}
            label={t('runningTime.legend.undefinedStoppage')}
          />
          <LegendItem
            color={RUNNING_TIME_COLOR.stoppedDefined}
            label={t('runningTime.legend.unplannedStoppage')}
          />
          <LegendItem
            color={RUNNING_TIME_COLOR.planned}
            label={t('runningTime.legend.plannedStoppage')}
          />
        </Stack>
      }
    >
      <InfoOutlined sx={{color: 'secondary.main', ml: 1.5}} />
    </Tooltip>
  )
}
